.mainContainer {
  display: flex;
  width: 100%;
  padding: 30px;
}
